var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgRakValuePlus = function SvgRakValuePlus(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.05 9C75.689 9 80 13.643 80 19.496v41.009C80 66.297 75.394 71 69.701 71H10.298C4.606 71 0 66.297 0 60.505V19.496C0 13.683 4.5 9 10.172 9H70.05zm-59.878 2C5.622 11 2 14.77 2 19.496v41.009C2 65.201 5.72 69 10.298 69H69.7C74.281 69 78 65.201 78 60.505V19.496C78 14.716 74.55 11 70.05 11H10.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2F16",
    d: "M21.194 34.02l9.176 17.443a1 1 0 0 0 1.603.23l9.824-10.14 9.823 10.14a1 1 0 0 0 1.559-.153L68.99 27.057a1 1 0 0 0-1.68-1.086l-15.13 23.427-9.666-9.978a1 1 0 0 0-1.436 0l-9.581 9.89-9.376-17.82a1 1 0 0 0-1.75-.038L9.307 50.495a1 1 0 0 0 1.73 1.005l10.157-17.48z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRakValuePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rak-value-plus.8d2c2394.svg";
export { ForwardRef as ReactComponent };